import script from "./SignUpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpModal.vue?vue&type=script&setup=true&lang=js"

export default script